import BaseService from '../BaseService'
import axios from "axios";

class ReviewService extends BaseService {
    constructor() {
        super('/reviews');
    }

    countsMonthly ({ query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}/counts-monthly${q}`)
    }
}

export default new ReviewService()
